export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'User',
    route: 'users-list',
    icon: 'UserIcon'
  },
  {
    title: 'Menu',
    route: 'bars-menu',
    icon: 'ColumnsIcon',
  },
  {
    title: 'Banner',
    route: 'bars-banner',
    icon: 'ImageIcon',
  },
  {
    title: 'Event',
    route: 'bars-event',
    icon: 'CompassIcon',
  },
  {
    title: 'About',
    route: 'bars-about',
    icon: 'InfoIcon',
  },
  {
    title: 'Contact',
    route: 'bars-contact',
    icon: 'MailIcon',
  },
  {
    title: 'Service',
    route: 'bars-service',
    icon: 'CrosshairIcon',
  },
  
  {
    title: 'Gallery',
    route: 'bars-gallery',
    icon: 'ImageIcon',
  },
  {
    title: 'Message',
    route: 'bars-message',
    icon: 'MessageCircleIcon',
  },
  {
    title: 'Store Setting',
    route: 'bars-setting',
    icon: 'SettingsIcon',
  },
]
